import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
const ManufacturersDashboard = lazy(() => import('../containers/Manufacturers/ManufacturersDashboard'));
function ManufacturersRouts({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: url },
            React.createElement(ManufacturersDashboard, { url: url }))));
}
export default ManufacturersRouts;
